import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateField,
  List,
  TextField,
  TextInput,
  NumberField,
  ShowButton,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="id" alwaysOn />,
  <TextInput label="File" source="file" />,
  <TextInput label="Secuencia" source="sequence" />,
  <TextInput label="Porc Coverage" source="porc_coverage" />,
];

export const AbricateList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    sort={{ field: "id", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={25}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="file" />
      <TextField source="sequence" />
      <NumberField source="start" />
      <NumberField source="end" />
      <TextField source="strand" />
      <TextField source="gene" />
      <TextField source="coverage" />
      <TextField source="coverage_map" />
      <TextField source="gaps" />
      <NumberField source="porc_coverage" />
      <NumberField source="porc_identity" />
      <TextField source="database" />
      <TextField source="accesion" />
      <TextField source="product" />
      <TextField source="resistance" />
      <TextField source="total_sequences" />
      <TextField source="date" />
      <TextField source="date_int" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
      <ShowButton />
    </Datagrid>
  </List>
));
